import canUseDom from 'app/utilities/dom';

const env = canUseDom() ? window.__ENV__ : process.env;

const {
    API_BASE_URL,
    CLIENT_ID,
    CLIENT_SECRET,
    NODE_ENV,
    APP_ENV,
    SENTRY_DSN,
    APP_PORT,
    GOOGLE_TAG_MANAGER_CONTAINER_ID,
    GOOGLE_SITE_VERIFICATION,
    RECAPTCHA_KEY,
    CUSTOMLINC_BASE_URL,
} = env;

// Don't expose any of the following: CLIENT_ID, CLIENT_SECRET
export const clientEnv = {
    API_BASE_URL: '/api',
    NODE_ENV,
    APP_ENV,
    SENTRY_DSN,
    APP_PORT,
    GOOGLE_TAG_MANAGER_CONTAINER_ID,
    GOOGLE_SITE_VERIFICATION,
    RECAPTCHA_KEY,
    CUSTOMLINC_BASE_URL,
};

export default {
    API_BASE_URL,
    CLIENT_ID,
    CLIENT_SECRET,
    NODE_ENV,
    APP_ENV,
    SENTRY_DSN,
    APP_PORT,
    GOOGLE_TAG_MANAGER_CONTAINER_ID,
    GOOGLE_SITE_VERIFICATION,
    CUSTOMLINC_BASE_URL,
};

export const isProd = env.NODE_ENV === 'production';
export const isAppLocal = env.APP_ENV === 'local';
export const isAppUat = env.APP_ENV === 'uat';
export const isAppStaging = env.APP_ENV === 'staging';
export const isAppProd = env.APP_ENV === 'prod';
